import { itx } from "../../translationItx/itx";
import { SequenceStep, enumActions } from "../Guide";
import { ToDoItem } from "../ToDoItem";
import guideSequence_addFloor from "./guideSequence_addFloor";

// ContextMenuLables.addFloors
function sequence(type: string, lastToDoItem?: ToDoItem): Array<SequenceStep> {
  return [
    {
      action: enumActions.call,
      subSequence: () => {
        if (state.floors.size == 0) {
          return [
            {
              action: enumActions.explain,
              text: `das Projekt hat noch keine Etage,
              also muß ich zunächst noch eine Etage anlegen`,
            },
            ...guideSequence_addFloor(""),
            { action: enumActions.wait },
          ];
        } else {
          return undefined;
        }
      },
    },
    {
      action: enumActions.function,
      func: async (): Promise<void> => {
        state.selectionManager.selectedObject = state.floors.sortBy("tag")[0];
      },
    },
    {
      action: enumActions.wait,
    },
    {
      action: enumActions.focus,
      id: () => {
        return `tv-${state.floors.sortBy("tag")[0].id}`;
      }, // TreeNode without # or . prefix  #  is assumed
    },
    {
      action: enumActions.click,
      id: () => {
        return [
          `tv-${state.floors.sortBy("tag")[0].id}`, // TreeNode
          `ContextMenuLables_addRoom`, // Menu inside TreeNode
        ];
      },
    },
    {
      action: enumActions.wait, // wait until dialog is open
    },
    // {
    //   action: enumActions.explain,
    //   id: () => `RoomDialog_name`,

    //   text: itx("onBoardingSequences.tagNameNewRoom"),
    // },
    {
      action: enumActions.call,
      subSequence: () => {
        // calc here the name and tag
        let choosenName = "Zimmer 1"; // no itx
        let allPossibleName = [
          itx("step2.kitchen", "Küche"),
          itx("step2.livingRoom", "Wohnzimmer"),
          itx("step2.office", "Büro"),
          itx("step2.bathroom", "Bad"),
          itx("step2.guestRoom", "Kinderzimmer"),
          itx("step2.diningRoom", "Esszimmer"),
          itx("step2.housWiringRoom", "Hauswirtschaftsraum"),
        ];
        allPossibleName.forEach((possibility) => {
          let allreadyInProject = false;
          state.allRooms().forEach((room) => {
            if (room.name == possibility) {
              allreadyInProject = true;
            }
          });
          if (!allreadyInProject && choosenName == "Zimmer 1") {
            choosenName = possibility;
          }
        });

        return [
          {
            id: `RoomDialog_name`,
            action: enumActions.type,
            text: choosenName, // itx("onBoardingSequences.nameNewRoom", "Ein Neuer Raum"),
          },
        ];
      },
    },

    {
      id: `BaseDialog_ok`,
      action: enumActions.click,
    },
  ];
}

export default sequence;
